import { Children } from 'react';
import {
    Box,
    Heading,
    Stack,
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    Flex,
    Spacer,
} from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { Formik } from 'formik';
import { Card } from 'components/v4/Card';
import { Button } from 'components/v4';
import SectionHandler from './SectionHandler';
import {
    breadCrumbStyling,
    headingStyling,
    subHeadingStyling,
} from './formStyles';
import { useNavigate, Link } from 'react-router-dom';

const FormBase = ({
    children,
    breadCrumbTrail,
    header,
    initialValues,
    finalFormSubmit,
    subHeader,
    subHeaderComponent,
    noBackBtn,
    ufBackBtn,
    ufSaveBtn,
    backLink,
    extraCards,
    extraButton,
    sideDrawer,
    isDisabled = false,
}) => {
    const { darkMode } = useSelector((state) => state.settings);
    const navigate = useNavigate();
    const navBack = () => {
        if (Array.isArray(backLink)) {
            navigate(backLink[0], backLink[1]);
        } else {
            navigate(backLink);
        }
    };

    const childrenCount = Children.count(children({}));
    return (
        <Box>
            <Breadcrumb sx={breadCrumbStyling}>
                {breadCrumbTrail?.map((crumb, index) => (
                    <BreadcrumbItem key={index}>
                        {Array.isArray(crumb.path) ? (
                            <BreadcrumbLink
                                as={Link}
                                to={crumb.path[0]}
                                state={crumb.path[1]}>
                                {crumb.label}
                            </BreadcrumbLink>
                        ) : (
                            <BreadcrumbLink as={Link} to={crumb.path}>
                                {crumb.label}
                            </BreadcrumbLink>
                        )}
                    </BreadcrumbItem>
                ))}
            </Breadcrumb>
            <Stack>
                {typeof header === 'string' ? (
                    <Heading sx={headingStyling}>{header}</Heading>
                ) : (
                    header
                )}
            </Stack>
            <Formik
                initialValues={initialValues}
                enableReinitialize
                onSubmit={(value) => {
                    finalFormSubmit(value);
                }}
                validateOnChange>
                {({ errors, touched, handleSubmit, values }) => (
                    <form onSubmit={handleSubmit}>
                        <Stack spacing={30}>
                            <Card
                                borderRadius={15}
                                padding="0px 30px"
                                maxWidth={895}
                                ml={0}
                                bg={darkMode ? 'dark.tcap' : null}>
                                <Stack sx={{ margin: '0 !important' }}>
                                    {subHeader && (
                                        <Flex
                                            sx={{
                                                paddingBottom: '15px',
                                                paddingTop: '25px',
                                            }}>
                                            <Heading sx={subHeadingStyling}>
                                                {subHeader}
                                            </Heading>
                                            <Spacer />
                                            <Box paddingRight="34px">
                                                {subHeaderComponent}
                                            </Box>
                                        </Flex>
                                    )}
                                    {Children.map(
                                        children({
                                            errors,
                                            touched,
                                            values,
                                        }),
                                        (child, index) => (
                                            <SectionHandler
                                                index={index}
                                                child={child}
                                                count={childrenCount}
                                            />
                                        ),
                                    )}
                                </Stack>
                            </Card>
                            {!!extraCards &&
                                extraCards.map((item, index) => (
                                    <Card
                                        key={index}
                                        borderRadius={15}
                                        maxWidth={895}
                                        ml={0}
                                        bg={darkMode ? 'dark.tcap' : null}>
                                        {item}
                                    </Card>
                                ))}
                            <Stack
                                direction="row"
                                maxWidth={895}
                                sx={{
                                    paddingBottom: sideDrawer ? 3 : 10,
                                    marginLeft: sideDrawer && 0,
                                    marginTop: sideDrawer && 25,
                                    paddingTop: sideDrawer && 3,
                                    position: sideDrawer ? 'sticky' : 'static',
                                    left: sideDrawer ? 0 : 'auto',
                                    bottom: sideDrawer ? -35 : 'auto',
                                    backgroundColor:
                                        sideDrawer &&
                                        (darkMode
                                            ? 'var(--chakra-colors-dark-bgDark)'
                                            : '#F5F5F5'),
                                    zIndex: 1,
                                    width: '100%',
                                }}>
                                <div
                                    className="edit-form-buttons"
                                    style={{
                                        border: 'none',
                                        textAlign: 'center',
                                        justifyContent: 'center',
                                    }}>
                                    <Button
                                        type="submit"
                                        isDisabled={isDisabled}
                                        data-walkthroughid={ufSaveBtn}
                                        className="h-10 min-w-[5rem] font-semibold disabled:cursor-not-allowed"
                                        sx={{ width: 142 }}>
                                        Save
                                    </Button>
                                    {!noBackBtn && (
                                        <div
                                            style={{
                                                marginLeft: 30,
                                                display: 'inline',
                                            }}>
                                            <Button
                                                className="secondary h-10 min-w-[5rem] font-semibold"
                                                variant="outline"
                                                sx={{ width: 142 }}
                                                data-walkthroughid={ufBackBtn}
                                                onClick={navBack}>
                                                Back
                                            </Button>
                                        </div>
                                    )}
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        flex: 1,
                                    }}>
                                    {extraButton}
                                </div>
                            </Stack>
                        </Stack>
                    </form>
                )}
            </Formik>
        </Box>
    );
};

export default FormBase;
